import React from 'react';
import { Translate } from 'react-localize-redux';
import { isNullOrUndefined } from '../../../store/storeFunctions';

export const industryAnalysisReportType = {
    financialRatios: "financialRatios",
    structuralIndicators: "structuralIndicators"
};

export class IndustryAnalysisReportTable {
    constructor(reportType, year, header, labels) {
        this.reportType = reportType;
        this.year = year;
        this.header = header;
        this.labels = labels;
        this.t1 = 0; this.t2 = 0; this.t3 = 0; this.t4 = 0;
        this.a1 = 0; this.a2 = 0; this.a3 = 0;
        this.o1 = 0; this.o2 = 0; this.o3 = 0;
    }

    renderHeader() {
        for (let i = 0; i < this.header.length; i++) {
            if (this.header[i].type === "T1" && this.header[i].year === this.year - 3)
                this.t1 = this.header[i].value;
            if (this.header[i].type === "T1" && this.header[i].year === this.year - 2)
                this.t2 = this.header[i].value;
            if (this.header[i].type === "T1" && this.header[i].year === this.year - 1)
                this.t3 = this.header[i].value;
            if (this.header[i].type === "T1" && this.header[i].year === this.year)
                this.t4 = this.header[i].value;

            if (this.header[i].type === "A1" && this.header[i].year === this.year) this.a1 = this.header[i].value;
            if (this.header[i].type === "A2" && this.header[i].year === this.year) this.a2 = this.header[i].value;
            if (this.header[i].type === "A3" && this.header[i].year === this.year) this.a3 = this.header[i].value;
            if (this.header[i].type === "O1" && this.header[i].year === this.year) this.o1 = this.header[i].value;
            if (this.header[i].type === "O2" && this.header[i].year === this.year) this.o2 = this.header[i].value;
            if (this.header[i].type === "O3" && this.header[i].year === this.year) this.o3 = this.header[i].value;
        }

        return (
            <tr>
                <td className="right">{this.t1}</td>
                <td className="right">{this.t2}</td>
                <td className="right">{this.t3}</td>
                <td className="right">{this.t4}</td>
                <td>{<Translate id="RatioBook.Common.BusinessSubjects" options={{ renderInnerHtml: true }} />}</td>
                <td></td>
                {(this.reportType === industryAnalysisReportType.financialRatios) &&
                    <td></td>}
                <td>{<Translate id="RatioBook.Common.Count" options={{ renderInnerHtml: true }} />}</td>
                <td className="right">{this.a1}</td>
                <td className="right">{this.a2}</td>
                <td className="right">{this.a3}</td>
                <td className="right">{this.o1}</td>
                <td className="right">{this.o2}</td>
                <td className="right">{this.o3}</td>
            </tr>
        );
    }

    renderLabels() {
        return (
            <>
                <tr>
                    <th rowSpan="2" className="right">{this.year - 3}</th>
                    <th rowSpan="2" className="right">{this.year - 2}</th>
                    <th rowSpan="2" className="right">{this.year - 1}</th>
                    <th rowSpan="2" className="right">{this.year}</th>
                    <th rowSpan="2" >{<Translate id="RatioBook.Common.Ratio" options={{ renderInnerHtml: true }} />}</th>
                    <th rowSpan="2" >{<Translate id="IndustryAnalysis.Result.MentalPicture" options={{ renderInnerHtml: true }} />}</th>
                    <th rowSpan="2" className="center">{<Translate id="RatioBook.Common.StatChar" options={{ renderInnerHtml: true }} />}</th>
                    {(this.reportType === industryAnalysisReportType.financialRatios) &&
                        <th rowSpan="2" className="center">{<Translate id="RatioBook.Common.Unit" options={{ renderInnerHtml: true }} />}</th>}
                    <th colSpan="3" className="center">{<Translate id="RatioBook.Common.AssetsInMilSk" options={{ renderInnerHtml: true }} />}</th>
                    <th colSpan="3" className="center">{<Translate id="RatioBook.Common.TurnoverInMilSk" options={{ renderInnerHtml: true }} />}</th>
                </tr>
                <tr>
                    <th className="center nowrap"> &lt;&nbsp;1,6 </th>
                    <th className="center nowrap">1,6-5,0</th>
                    <th className="center nowrap">&gt;&nbsp;5,0</th>
                    <th className="center nowrap">&lt;&nbsp;0,8</th>
                    <th className="center nowrap">0,8-3,3</th>
                    <th className="center nowrap">&gt;&nbsp;3,3</th>
                </tr>
            </>
        );
    }
}

export class IndustryAnalysisReportTableBodyItem {
    constructor(reportType, year, item) {
        this.reportType = reportType;
        this.year = year;
        this.item = item;

        this.t1_dk = 0; this.t2_dk = 0; this.t3_dk = 0; this.t4_dk = 0;
        this.t1_me = 0; this.t2_me = 0; this.t3_me = 0; this.t4_me = 0;
        this.t1_hk = 0; this.t2_hk = 0; this.t3_hk = 0; this.t4_hk = 0;
        this.t1_mn = 0; this.t2_mn = 0; this.t3_mn = 0; this.t4_mn = 0;

        this.a1_dk = 0; this.a2_dk = 0; this.a3_dk = 0;
        this.a1_me = 0; this.a2_me = 0; this.a3_me = 0;
        this.a1_hk = 0; this.a2_hk = 0; this.a3_hk = 0;
        this.a1_mn = 0; this.a2_mn = 0; this.a3_mn = 0;

        this.o1_dk = 0; this.o2_dk = 0; this.o3_dk = 0;
        this.o1_me = 0; this.o2_me = 0; this.o3_me = 0;
        this.o1_hk = 0; this.o2_hk = 0; this.o3_hk = 0;
        this.o1_mn = 0; this.o2_mn = 0; this.o3_mn = 0;

        this.name = "";
        this.mo = "";
        this.unit ="";
        this.rowLevel = undefined;
    }

    renderBodyItem(key) {
        this.getData(this.item);

        const dk = <Translate id="RatioBook.Common.DK" options={{ renderInnerHtml: true }} />
        const hk = <Translate id="RatioBook.Common.HK" options={{ renderInnerHtml: true }} />
        const me = <Translate id="RatioBook.Common.Me" options={{ renderInnerHtml: true }} />
        const mn = <Translate id="IndustryAnalysis.Result.Avg" options={{ renderInnerHtml: true }} />
        const className = !isNullOrUndefined(this.rowLevel) ? `statement-level-${this.rowLevel}` : undefined;

        return (
            <React.Fragment key={key}>
                <tr className={className}>
                    <td className="right">{this.t1_dk}</td>
                    <td className="right">{this.t2_dk}</td>
                    <td className="right">{this.t3_dk}</td>
                    <td className="right">{this.t4_dk}</td>
                    <td rowSpan="4">{this.name}</td>
                    <td rowSpan="4">{this.mo}</td>
                    <td className="center">{dk}</td>
                    {(this.reportType === industryAnalysisReportType.financialRatios) && <td rowSpan="4">{this.unit}</td>}
                    <td className="right">{this.a1_dk}</td>
                    <td className="right">{this.a2_dk}</td>
                    <td className="right">{this.a3_dk}</td>
                    <td className="right">{this.o1_dk}</td>
                    <td className="right">{this.o2_dk}</td>
                    <td className="right">{this.o3_dk}</td>
                </tr>
                <tr className={className}>
                    <td className="right">{this.t1_me}</td>
                    <td className="right">{this.t2_me}</td>
                    <td className="right">{this.t3_me}</td>
                    <td className="right">{this.t4_me}</td>
                    <td className="center">{me}</td>
                    <td className="right">{this.a1_me}</td>
                    <td className="right">{this.a2_me}</td>
                    <td className="right">{this.a3_me}</td>
                    <td className="right">{this.o1_me}</td>
                    <td className="right">{this.o2_me}</td>
                    <td className="right">{this.o3_me}</td>
                </tr>
                <tr className={className}>
                    <td className="right">{this.t1_hk}</td>
                    <td className="right">{this.t2_hk}</td>
                    <td className="right">{this.t3_hk}</td>
                    <td className="right">{this.t4_hk}</td>
                    <td className="center">{hk}</td>
                    <td className="right">{this.a1_hk}</td>
                    <td className="right">{this.a2_hk}</td>
                    <td className="right">{this.a3_hk}</td>
                    <td className="right">{this.o1_hk}</td>
                    <td className="right">{this.o2_hk}</td>
                    <td className="right">{this.o3_hk}</td>
                </tr>
                <tr className={className}>
                    <td className="right">{this.t1_mn}</td>
                    <td className="right">{this.t2_mn}</td>
                    <td className="right">{this.t3_mn}</td>
                    <td className="right">{this.t4_mn}</td>
                    <td className="center">{mn}</td>
                    <td className="right">{this.a1_mn}</td>
                    <td className="right">{this.a2_mn}</td>
                    <td className="right">{this.a3_mn}</td>
                    <td className="right">{this.o1_mn}</td>
                    <td className="right">{this.o2_mn}</td>
                    <td className="right">{this.o3_mn}</td>
                </tr>
            </React.Fragment>
        )
    }

    getData(item) {
        const itemData = item.data;

        for (let i = 0; i < itemData.length; i++) {
            if (itemData[i].type === "T1" && itemData[i].year === this.year - 3) {
                this.t1_dk = itemData[i].dk
                this.t1_me = itemData[i].me
                this.t1_hk = itemData[i].hk
                this.t1_mn = itemData[i].mn
            }
            if (itemData[i].type === "T1" && itemData[i].year === this.year - 2) {
                this.t2_dk = itemData[i].dk;
                this.t2_me = itemData[i].me;
                this.t2_hk = itemData[i].hk;
                this.t2_mn = itemData[i].mn;
            }
            if (itemData[i].type === "T1" && itemData[i].year === this.year - 1) {
                this.t3_dk = itemData[i].dk;
                this.t3_me = itemData[i].me;
                this.t3_hk = itemData[i].hk;
                this.t3_mn = itemData[i].mn;
            }
            if (itemData[i].type === "T1" && itemData[i].year === this.year) {
                this.t4_dk = itemData[i].dk;
                this.t4_me = itemData[i].me;
                this.t4_hk = itemData[i].hk;
                this.t4_mn = itemData[i].mn;
                this.mo = itemData[i].mo
            }
            if (itemData[i].type === "A1" && itemData[i].year === this.year) {
                this.a1_dk = !itemData[i].isNullOrUndefined ? itemData[i].dk : 0;
                this.a1_me = !itemData[i].isNullOrUndefined ? itemData[i].me : 0;
                this.a1_hk = !itemData[i].isNullOrUndefined ? itemData[i].hk : 0;
                this.a1_mn = !itemData[i].isNullOrUndefined ? itemData[i].mn : 0;
            }
            if (itemData[i].type === "A2" && itemData[i].year === this.year) {
                this.a2_dk = !itemData[i].isNullOrUndefined ? itemData[i].dk : 0;
                this.a2_me = !itemData[i].isNullOrUndefined ? itemData[i].me : 0;
                this.a2_hk = !itemData[i].isNullOrUndefined ? itemData[i].hk : 0;
                this.a2_mn = !itemData[i].isNullOrUndefined ? itemData[i].mn : 0;
            }
            if (itemData[i].type === "A3" && itemData[i].year === this.year) {
                this.a3_dk = !itemData[i].isNullOrUndefined ? itemData[i].dk : 0;
                this.a3_me = !itemData[i].isNullOrUndefined ? itemData[i].me : 0;
                this.a3_hk = !itemData[i].isNullOrUndefined ? itemData[i].hk : 0;
                this.a3_mn = !itemData[i].isNullOrUndefined ? itemData[i].mn : 0;
            }
            if (itemData[i].type === "O1" && itemData[i].year === this.year) {
                this.o1_dk = !itemData[i].isNullOrUndefined ? itemData[i].dk : 0;
                this.o1_me = !itemData[i].isNullOrUndefined ? itemData[i].me : 0;
                this.o1_hk = !itemData[i].isNullOrUndefined ? itemData[i].hk : 0;
                this.o1_mn = !itemData[i].isNullOrUndefined ? itemData[i].mn : 0;
            }
            if (itemData[i].type === "O2" && itemData[i].year === this.year) {
                this.o2_dk = !itemData[i].isNullOrUndefined ? itemData[i].dk : 0;
                this.o2_me = !itemData[i].isNullOrUndefined ? itemData[i].me : 0;
                this.o2_hk = !itemData[i].isNullOrUndefined ? itemData[i].hk : 0;
                this.o2_mn = !itemData[i].isNullOrUndefined ? itemData[i].mn : 0;
            }
            if (itemData[i].type === "O3" && itemData[i].year === this.year) {
                this.o3_dk = !itemData[i].isNullOrUndefined ? itemData[i].dk : 0;
                this.o3_me = !itemData[i].isNullOrUndefined ? itemData[i].me : 0;
                this.o3_hk = !itemData[i].isNullOrUndefined ? itemData[i].hk : 0;
                this.o3_mn = !itemData[i].isNullOrUndefined ? itemData[i].mn : 0;
            }
        }

        this.name = item.description;

        if (this.reportType === industryAnalysisReportType.financialRatios) {
            this.unit = item.unit;
        }

        if (this.reportType === industryAnalysisReportType.structuralIndicators) {
            this.rowLevel = item.rowLevel;
        }
    }
}



